<template>

    <section class="c-transfer">
        <h3>Przekaż dokumentację Fizjoterapucie</h3>
        <form @submit.prevent="submit('transfer-form')" data-vv-scope="transfer-form">
            <form-desc>
                Podaj numer PWZFz do którego chcesz przekazać dokumentację wybranego pacjenta.
                Jeśli posiada on konto w EDF powiadomimy go o transferze i poprosimy o akceptację.
            </form-desc>
            <form-row>
                <form-select
                    label="Wybierz pacjenta"
                    :options="patientsList"
                    v-model="transferPatientId"
                    data-vv-as="pacjent"
                    v-validate="'required'">
                </form-select>
                <form-input
                    v-model="pwz"
                    label="Podaj numer PWZFz"
                    data-vv-as="PWZFz"
                    v-validate="'required|PWZ'">
                </form-input>
            </form-row>
            <form-desc>
                Jeśli Fizjoterapeuta zaakceptuje transfer utracisz dostęp do dokumentacji wybranego pacjenta.
            </form-desc>
            <form-row align="right">
                <v-btn
                    type="green"
                    role="submit"
                    has-loader
                    :loading="isLoading">
                    Zapisz
                </v-btn>
            </form-row>
        </form>
    </section>

</template>


<script>

import {mapGetters} from 'vuex'
import {FormDesc, FormRow, FormInput, FormSelect} from 'Components/Form'
import VBtn from 'Components/VBtn'
import FileDownload from 'js-file-download'

export default {

    name: 'SettingsTransfer',

    data() {
        return {
            transferPatientId: null,
            pwz: null,
            isLoading: false
        }
    },

    computed: {
        ...mapGetters(['patientsList']),
    },

    methods: {
        submit(scope) {
            this.isLoading = true
            this.$validator.validateAll(scope).then((isValid) => {
                if (isValid) {
                    this.transferDoc()
                } else {
                    this.isLoading = false
                }
            })
        },
        transferDoc() {
            this.$store.dispatch('PHT_TRANSFER_PATIENT_DOC', {
                patient_id: this.transferPatientId,
                pwz: this.pwz
            }).then((response) => {
                this.isLoading = false
                this.$alert.success('Przekaż dokumentację Fizjoterapucie', response.data.message)
                this.transferPatientId = null
                this.pwz = null
                this.$validator.reset()
            }).catch((error) => {
                this.isLoading = false
                this.$alert.error('Przekaż dokumentację Fizjoterapucie', error.response.data.message)
            })
        }
    },

    components: {
        VBtn,
        FormDesc,
        FormRow,
        FormInput,
        FormSelect
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-transfer {

}

</style>
